export function resetBodyDragChromeStyles() {
  document.body.style.removeProperty("cursor");
  document.body.style.removeProperty("user-select");
}
